import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

import Utils from '../../shared/utility';
import { MatDialog } from '@angular/material/dialog';

import { AdjustDesiredClaimAgeComponent } from '../../shared/modal/adjust-desired-claim-age/adjust-desired-claim-age.component';
import { LoadingService } from '../loading/loading.service';


@Component({
    selector: 'app-social-security-illustration-card',
    templateUrl: './social-security-illustration-card.component.html',
    styleUrls: ['social-security-illustration-card.component.css']
})

export class SocialSecurityIllustrationCardComponent implements OnInit {
    @Input() scenario: string = "";
    @Input() color: string = "";
    @Input() startAge: number[] = [];
    @Input() clientName: string;
    @Input() clientTotal: number;
    @Input() clientAge: any;
    @Input() clientCurrentAge: number;
    @Input() clientFRA: any;
    @Input() clientRetroNumMonths: any;
    @Input() partnerRetroNumMonths: any;      
    @Input() clientRetroDisplayAge: any;
    @Input() partnerRetroDisplayAge: any;  
    @Input() partnerName: string = "";
    @Input() partnerAge: any;
    @Input() partnerCurrentAge: number;
    @Input() partnerFRA: any;
    @Input() partnerTotal: number;
    @Input() medicareDeductions: string;
    @Input() netOfMedicare: number;
    @Input() adjustDesiredData;
    @Input() isClientAlreadyClaiming: boolean = false;
    @Input() isPartnerAlreadyClaiming: boolean = false;
    @Input() displayRemoveAltIcon: boolean = false;
    @Input() dependentChildrenSumTotal: string = "";
    // @Input() clientDOB: any;
    // @Input() partnerDOB: any;
    
    @Output() adjustDesiredScenarioEvent = new EventEmitter<any>();
    @Output() adjustFRAScenarioEvent = new EventEmitter<any>();
    @Output() removeDesiredScenarioEvent = new EventEmitter<any>();
    @Output() removeFRAScenarioEvent = new EventEmitter<any>();

    includePartner: boolean;
    showAddAlternate: boolean = false;
    isDisabled: boolean = false;
    partnerRetroMonths: string;
    clientRetroMonths: string;
    clientAgeYears: any;
    clientAgeMonths: any;
    spouseAgeYears: any;
    spouseAgeMonths: any;
    cardType: any;
    showDependentChildBenefits: boolean = false;

    constructor(private router: Router, public dialog: MatDialog, public loadingService: LoadingService) {
        this.adjustDesiredScenarioEvent = new EventEmitter();
        this.adjustFRAScenarioEvent = new EventEmitter();
        this.removeDesiredScenarioEvent = new EventEmitter();
        this.removeFRAScenarioEvent = new EventEmitter();
        
    }

    ngOnInit() {
        this.showDependentChildBenefits = (this.dependentChildrenSumTotal && Utils.removeCurrencyFormatting(this.dependentChildrenSumTotal) > 0) ? true : false;

        this.cardType = (this.scenario.includes('Second Alternate') || this.scenario == 'Alternate (Retroactive File)' || this.scenario == 'Alternate') ? 'alternate' 
        : (this.scenario.includes('First Alternate') || this.scenario == 'FRA') ? 'fra' 
        : (this.scenario.includes('Earliest')) ? 'earliest' 
        : 'optimal';
        //this.includePartner = Utils.formatToNumber(this.partnerTotal) > 0;
        //console.log('isClientAlreadyClaiming', this.isClientAlreadyClaiming);
        //console.log('isPartnerAlreadyClaiming', this.isPartnerAlreadyClaiming);
        console.log('this.adjustDesiredData', this.adjustDesiredData);
        this.includePartner = (this.partnerName) ? true : false;
        this.showAddAlternate = (this.scenario == "AddAlternate") ? true : false;
        //this.isDisabled = (this.includePartner ? (((this.clientCurrentAge < 70 || this.partnerCurrentAge < 70) && (!this.isClientAlreadyClaiming || !this.isPartnerAlreadyClaiming)) ? false : true) : this.clientCurrentAge >= 70);
        this.isDisabled = (this.includePartner ? (((!this.isClientAlreadyClaiming || !this.isPartnerAlreadyClaiming)) ? false : true) : this.clientCurrentAge >= 70);
        // to populate the claim age if someone delete the alt card
        this.clientAgeYears = this.adjustDesiredData.clientAgeYears;
        this.clientAgeMonths = this.adjustDesiredData.clientAgeMonths;
        this.spouseAgeYears = this.adjustDesiredData.spouseAgeYears;
        this.spouseAgeMonths = this.adjustDesiredData.spouseAgeMonths;
        //console.log('isDisabled', this.scenario + ' ' + this.isDisabled);
        console.log('clienFRA modal', this.clientFRA);
        // console.log('client real age', this.clientCurrentAge);
        // console.log('scenario', this.scenario)
        // if (this.clientRetroMonths) {
        //     console.log('clientRetroMonths', this.clientRetroMonths);
        // }

        if(this.clientFRA){
            console.log('this.clientFRA', this.clientFRA);
            console.log('this.clientAge', this.clientAge)        
            var retroMonthsPast = (((parseInt(this.clientAge.replaceAll(' ', '').split('y')[0]) * 12) + parseInt(this.clientAge.replaceAll(' ', '').split('y')[1].split('m')[0])) - ((this.clientFRA.age * 12) + this.clientFRA.month));
            // if clientAge year is greater than client real age or if client age year equal to client real age but clientAge month is greater than client real age month
            // if clientAge year is equal to clieant real age year and clientAge month is greater than client real age month but less than retromonth past then retro month supposed to equal differene between client real age month and client Age month
            this.clientRetroMonths = (retroMonthsPast > 0) ? retroMonthsPast >= 6 ? '6' : retroMonthsPast.toString() : '';

            if(this.clientRetroNumMonths){
                this.clientRetroMonths = this.clientRetroNumMonths;
                this.adjustDesiredData.clientRetroNumMonths = this.clientRetroNumMonths;
            }

            if(this.clientRetroDisplayAge){
                this.clientAge = this.clientRetroDisplayAge;
                this.adjustDesiredData.clientRetroDisplayAge = this.clientRetroDisplayAge;
            }
            // let clientRealAge = this.calculateAge(this.clientDOB);
            // let clientBenefitAge = parseInt(this.clientAge.replaceAll(' ', '').split('y')[0])
            // console.log('clientRealAge', clientRealAge);
            // console.log('clientAge', clientBenefitAge);
            // if (clientBenefitAge <= clientRealAge) {
            //     this.clientRetroMonths = this.adjustDesiredData.clientRetroNumMonths = '';
            // }

        }

        console.log('test entrance');
        if(this.partnerFRA){
            console.log('has partnerFRA value');
            var retroMonthsPast = (((parseInt(this.partnerAge.replaceAll(' ', '').split('y')[0]) * 12) + parseInt(this.partnerAge.replaceAll(' ', '').split('y')[1].split('m')[0])) - ((this.partnerFRA.age * 12) + this.partnerFRA.month));
            this.partnerRetroMonths = (retroMonthsPast > 0) ? retroMonthsPast >= 6 ? '6' : retroMonthsPast.toString() : '';
            //console.log('partner FRA in from Modal', this.partnerRetroMonths);

            if(this.partnerRetroNumMonths){
                this.partnerRetroMonths = this.partnerRetroNumMonths;
                this.adjustDesiredData.partnerRetroNumMonths = this.partnerRetroNumMonths;
            }

            if(this.partnerRetroDisplayAge){
                console.log('i am in here setting stuff up');
                this.partnerAge = this.partnerRetroDisplayAge;
                console.log('i am in here setting stuff up', this.partnerAge);
                this.adjustDesiredData.partnerRetroDisplayAge = this.partnerRetroDisplayAge;
                console.log('i am in here setting stuff up', this.adjustDesiredData.partnerRetroDisplayAge);
            }
            // let partnerRealAge = this.calculateAge(this.partnerDOB);
            // let partnerBenefitAge = parseInt(this.partnerAge.replaceAll(' ', '').split('y')[0])
            // console.log('partnerRealAge', partnerRealAge);
            // console.log('partnerAge', partnerBenefitAge);
            // if (partnerBenefitAge <= partnerRealAge) {
            //     this.partnerRetroMonths = this.adjustDesiredData.partnerRetroNumMonths = '';
            // }

        }
    }

    calculateTotals() {
        return Utils.formatToCurrency(Utils.formatToNumber(this.clientTotal) + (this.includePartner ? Utils.formatToNumber(this.partnerTotal) : 0) + Utils.removeCurrencyFormatting(this.dependentChildrenSumTotal));
    }

    formatMoney(val) {
        return Utils.formatToCurrency(val);
    }

    adjustDesired(isDisabled) {        
        if(isDisabled){
            //show popup explaining why this is disabled?

        } else {
            console.log('adjustDesiredData 2', this.adjustDesiredData);
            if (this.showAddAlternate) {
                this.adjustDesiredData.clientAgeYears = this.clientAgeYears;
                this.adjustDesiredData.clientAgeMonths = this.clientAgeMonths;
                this.adjustDesiredData.spouseAgeYears = this.spouseAgeYears;
                this.adjustDesiredData.spouseAgeMonths = this.spouseAgeMonths;
            }

            const dialogRef = this.dialog.open(AdjustDesiredClaimAgeComponent, {
                //width: '1000px',
                //height: '700px',
                data: this.adjustDesiredData
            });
        
            dialogRef.afterClosed().subscribe(result =>{
                //recalc illustration page here with new ROR values
                //console.log('from close', result);
                if(result){
                
                console.log('return from desired adjust', result);
                this.loadingService.isLoading(true);
                this.adjustDesiredScenarioEvent.emit(result);
                }
            });
        }
    }

    removeAltScenario(){
        this.showAddAlternate = true;
        this.removeDesiredScenarioEvent.emit(this.showAddAlternate);
        console.log('adjustDesiredData 1', this.adjustDesiredData);
    }

    adjustFRA(isDisabled) {        
        if(isDisabled){
            //show popup explaining why this is disabled?

        } else {

            const dialogRef = this.dialog.open(AdjustDesiredClaimAgeComponent, {
                data: this.adjustDesiredData
            });
        
            dialogRef.afterClosed().subscribe(result =>{
                if(result){                
                    console.log('return from fra adjust', result);
                    this.loadingService.isLoading(true);
                    this.adjustFRAScenarioEvent.emit(result);
                }
            });
        }
    }

    removeFRAScenario(){
        //TODO: reset Alternate 2 to be FRA again
        this.removeFRAScenarioEvent.emit(true);
    }
    // calculateAge(birthday) {
    //     birthday = new Date(birthday);
    //     let currentDate = new Date();
    //     let currentAgeOffset = (currentDate.getMonth() < birthday.getMonth()) ? 1 : 0;
    //     // console.log('currentAgeOffset', currentAgeOffset);
    //     let currentAge = (currentDate.getFullYear() - birthday.getFullYear()) - currentAgeOffset;
    //     return currentAge;
    //     // console.log('birthday', birthday);
    //     // var ageDifMs = Date.now() - birthday;
    //     // // console.log('ageDifMs', ageDifMs);
    //     // var ageDate = new Date(ageDifMs);
    //     // return Math.abs(ageDate.getUTCFullYear() - 1970);
    //   }
    
}